var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttendance = function SvgAttendance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.5 2.125h3.125a.625.625 0 0 1 .625.625v13.125a.625.625 0 0 1-.625.625H1.375a.625.625 0 0 1-.625-.625V2.75a.625.625 0 0 1 .625-.625H4.5m5.833 6.458-3.889 3.334L4.5 10.25m-.625-5.625V4a3.125 3.125 0 0 1 6.25 0v.625z"
  })));
};
export default SvgAttendance;